import { downgradeComponent } from '@angular/upgrade/static';
import { ScheduleEditorContainerComponent } from '@mode/shared/schedules/feature-schedule-editor';
import * as angular from 'angular';

export const DowngradedSharedFeatureScheduleEditorModule = angular
  .module('downgraded-shared-feature-schedule-editor', [])
  .directive('modeScheduleEditorContainer', downgradeComponent({ component: ScheduleEditorContainerComponent })).name;
